"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getServiceCategoryAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getServiceCategory, tokenData);
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getServiceCategoryDetailAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_DETAIL_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getServiceCategoryDetail, params.data.params.HISId, params.data.params.queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_DETAIL_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_DETAIL_API.failure(err));
  }
}
function* getServicesPackagesAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_SERVICES_PACKAGES_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getServicesPackages, params.data.queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_SERVICES_PACKAGES_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SERVICES_PACKAGES_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getAutoSuggestionHomecareSearchAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_AUTOSUGGEST_HOMECARE_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAutoSuggestionHomecareSearch, params.data.queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_AUTOSUGGEST_HOMECARE_SEARCH_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_AUTOSUGGEST_HOMECARE_SEARCH_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getMultipleServiceCategoryDetailAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_MULTIPLE_SERVICE_CATEGORY_DETAIL_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getMultipleServiceCategoryDetail, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_MULTIPLE_SERVICE_CATEGORY_DETAIL_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_MULTIPLE_SERVICE_CATEGORY_DETAIL_API.failure(err));
  }
}
function* getConsentFormAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_CONSENT_FORM_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getConsentForm, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_CONSENT_FORM_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_CONSENT_FORM_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getServiceCategoryCarouselAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_CAROUSEL_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getServiceCategoryCarousel, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_CAROUSEL_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SERVICE_CATEGORY_CAROUSEL_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getCheckServiceAvailabilityAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_LOCATION_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCheckServiceAvailability, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_LOCATION_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_LOCATION_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getServicePriceAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_SERVICE_PRICE_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getServicePrice, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_SERVICE_PRICE_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SERVICE_PRICE_API.failure(err));
  }
}
function* watchers() {
  yield (0, _effects.takeEvery)(actions.GET_SERVICE_CATEGORY, getServiceCategoryAPI);
  yield (0, _effects.takeEvery)(actions.GET_SERVICE_CATEGORY_DETAIL, getServiceCategoryDetailAPI);
  yield (0, _effects.takeEvery)(actions.GET_SERVICES_PACKAGES, getServicesPackagesAPI);
  yield (0, _effects.takeEvery)(actions.GET_MULTIPLE_SERVICE_CATEGORY_DETAIL, getMultipleServiceCategoryDetailAPI);
  yield (0, _effects.takeLatest)(actions.GET_CONSENT_FORM, getConsentFormAPI);
  yield (0, _effects.takeLatest)(actions.GET_LOCATION, getCheckServiceAvailabilityAPI);
  yield (0, _effects.takeEvery)(actions.GET_SERVICE_CATEGORY_CAROUSEL, getServiceCategoryCarouselAPI);
  yield (0, _effects.takeEvery)(actions.GET_AUTOSUGGEST_HOMECARE_SEARCH, getAutoSuggestionHomecareSearchAPI);
  yield (0, _effects.takeEvery)(actions.GET_SERVICE_PRICE, getServicePriceAPI);
}